import { useCallback, useEffect, useState } from 'react'

import { AboutTourObject, HotelDetailApi } from 'shared/api/tours/tour-detail'

export const useAboutTour = () => {
  const [aboutTour, setAboutTour] = useState<AboutTourObject[] | null>(null)

  const load = useCallback(async () => {
    try {
      const { data: response } = await HotelDetailApi.getAboutTour()
      setAboutTour(response.data)
    } catch (error) {
      console.error('Error fetching about tour:', error)
    }
  }, [])

  useEffect(() => {
    if (!aboutTour) load()
  }, [aboutTour, load])

  return aboutTour
}
